import { useCallback } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { ContactResult } from "../../../types/ContactResult";
import { useObx } from "../../../hooks/useObx";
import ApiRequestPaths from "../../../constants/ApiRequestPaths";

export interface IUseCreateContactResultProps {
  /** The id of the session's contact. */
  contactId: string;
}

/** A hook which dispatches the result for the session's contact to the OBX server. */
const useCreateContactResult: TriggeredHook<ContactResult, ContactResult, boolean, IUseCreateContactResultProps> = ({
  contactId
}) => {
  const { res, err, loading, setReq } = useObx<ContactResult, ContactResult>("Post Contact Result", {
    method: "post",
    url: ApiRequestPaths.postContactResult(contactId)
  });
  const execute = useCallback((contactResult: ContactResult) => setReq(r => r && { ...r, payload: contactResult }), []);
  return { result: res?.payload || null, error: Boolean(err), isLoading: loading, execute };
};

export default useCreateContactResult;
